"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacySearchResponse = exports.SearchRequest = exports.SearchCriteria = exports.SearchResponse = exports.SearchResultItem = exports.ClassicScriptSchema = exports.ClassicSearchResult = exports.ScriptSearchResult = exports.RundownSearchResult = exports.DocumentTypeFilter = exports.SearchDocumentType = exports.SearchHighlight = void 0;
const zod_1 = require("zod");
const script_1 = require("./script");
const common_1 = require("./common");
const helpers = __importStar(require("./helpers"));
const common_2 = require("./common");
exports.SearchHighlight = zod_1.z.object({
    name: zod_1.z.array(zod_1.z.string()).optional(),
    textContent: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.SearchDocumentType = zod_1.z.enum(['script', 'rundown', 'classic']);
// archived results from scripto classic can be returned as search results, but not filtered on
exports.DocumentTypeFilter = zod_1.z.enum(['script', 'rundown']);
exports.RundownSearchResult = zod_1.z.object({
    documentType: zod_1.z.literal('rundown'),
    id: common_2.IntegerId,
    name: zod_1.z.string(),
    status: zod_1.z.null(),
    contentsModifiedAt: common_1.SerializableDate,
    contentsModifiedBy: common_2.Uuid,
    folderId: common_2.Uuid,
    icon: zod_1.z.null(),
    highlight: exports.SearchHighlight,
});
exports.ScriptSearchResult = zod_1.z.object({
    documentType: zod_1.z.literal('script'),
    id: common_2.Uuid,
    name: zod_1.z.string(),
    status: script_1.SharedScriptStatus,
    contentsModifiedAt: common_1.SerializableDate,
    contentsModifiedBy: common_2.Uuid,
    folderId: common_2.Uuid,
    icon: common_1.FaIcon,
    highlight: exports.SearchHighlight,
});
const ClassicScriptBase = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    contentsModifiedAt: common_1.SerializableDate,
    inRundown: zod_1.z.boolean(),
    folderName: zod_1.z.string().optional(),
});
exports.ClassicSearchResult = ClassicScriptBase.extend({
    documentType: zod_1.z.literal('classic'),
    highlight: exports.SearchHighlight,
});
exports.ClassicScriptSchema = ClassicScriptBase.extend({
    text: zod_1.z.string(), // The body of the script
});
exports.SearchResultItem = zod_1.z.discriminatedUnion('documentType', [
    exports.RundownSearchResult,
    exports.ScriptSearchResult,
    exports.ClassicSearchResult,
]);
exports.SearchResponse = helpers.paginatedResult(exports.SearchResultItem);
exports.SearchCriteria = zod_1.z.object({
    phrase: zod_1.z.string().optional(),
    modifiedBefore: common_1.SerializableDate.optional(),
    modifiedAfter: common_1.SerializableDate.optional(),
    includeTitleOnly: zod_1.z.boolean().optional(),
    docType: exports.DocumentTypeFilter.optional(),
    includeTrash: zod_1.z.boolean().optional(),
    folderId: common_2.Uuid.optional(),
});
exports.SearchRequest = helpers.paginatedRequest(exports.SearchCriteria.shape);
exports.LegacySearchResponse = zod_1.z
    .object({
    total: zod_1.z.number().int().nonnegative(),
    range: zod_1.z.tuple([zod_1.z.number().int(), zod_1.z.number().int()]),
    results: zod_1.z.array(exports.SearchResultItem),
})
    .transform(({ total, range, results }) => ({
    total,
    results,
    from: range[0],
}));
